import { Grid, TextField } from "@mui/material";
import PhoneCountryInput from "../../components/PhoneCountryInput";
import dayjs from "dayjs";
import { useEffect } from "react";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

export default function ProfileItems({ formValues, setFormValues, type }) {
  const { t } = useTranslation();

  return (
    <>
      <Grid
        item
        xs={12}
        sm={type !== "modal" && 6}
        lg={type !== "modal" && 4}
        xl={type !== "modal" && 3}
      >
        <TextField
          disabled={type !== "modal"}
          fullWidth
          sx={{ textTransform: 'capitalize' }}
          value={formValues?.username}
          id="outlined-basic"
          label={t("userEmail")}
          name="username"
          variant="outlined"
        />
      </Grid>
      {/* <Grid
        item
        xs={12}
        sm={type !== "modal" && 6}
        lg={type !== "modal" && 4}
        xl={type !== "modal" && 3}
      >
        <PhoneCountryInput
          formValues={formValues}
          setFormValues={setFormValues}
          disabled={type !== "modal" && true}
        />
      </Grid> */}

      <Grid
        item
        xs={12}
        sm={type !== "modal" && 6}
        lg={type !== "modal" && 4}
        xl={type !== "modal" && 3}
      >
        <TextField
          disabled={type !== "modal"}
          fullWidth
          value={formValues?.tax_address}
          id="outlined-basic"
          sx={{ textTransform: 'capitalize' }}
          label={t("taxAddress")}
          name="tax_address"
          variant="outlined"
        />
      </Grid>

      <Grid
        item
        xs={12}
        sm={type !== "modal" && 6}
        lg={type !== "modal" && 4}
        xl={type !== "modal" && 3}
      >
        <TextField
          disabled={type !== "modal"}
          fullWidth
          value={formValues?.tax_office}
          id="outlined-basic"
          sx={{ textTransform: 'capitalize' }}
          label={t("taxOffice")}
          name="tax_office"
          variant="outlined"
        />
      </Grid>

      <Grid
        item
        xs={12}
        sm={type !== "modal" && 6}
        lg={type !== "modal" && 4}
        xl={type !== "modal" && 3}
      >
        <TextField
          disabled={type !== "modal"}
          fullWidth
          value={formValues?.agent_name}
          id="outlined-basic"
          sx={{ textTransform: 'capitalize' }}
          label={t("agentName")}
          name="agent_name"
          variant="outlined"
        />
      </Grid>

      <Grid
        item
        xs={12}
        sm={type !== "modal" && 6}
        lg={type !== "modal" && 4}
        xl={type !== "modal" && 3}
      >
        <TextField
          disabled={type !== "modal"}
          fullWidth
          value={formValues?.address}
          id="outlined-basic"
          sx={{ textTransform: 'capitalize' }}
          label={t("address")}
          name="address"
          variant="outlined"
        />
      </Grid>

      <Grid
        item
        xs={12}
        sm={type !== "modal" && 6}
        lg={type !== "modal" && 4}
        xl={type !== "modal" && 3}
      >
        <TextField
          disabled={type !== "modal"}
          fullWidth
          value={formValues?.tax_name}
          id="outlined-basic"
          sx={{ textTransform: 'capitalize' }}
          label={t("taxName")}
          name="tax_name"
          variant="outlined"
        />
      </Grid>

      <Grid
        item
        xs={12}
        sm={type !== "modal" && 6}
        lg={type !== "modal" && 4}
        xl={type !== "modal" && 3}
      >
        <TextField
          disabled={type !== "modal"}
          fullWidth
          value={formValues?.tax_number}
          id="outlined-basic"
          sx={{ textTransform: 'capitalize' }}
          label={t("taxNumber")}
          name="tax_number"
          variant="outlined"
        />
      </Grid>

      {type !== "modal" && (
        <Grid
          item
          xs={12}
          sm={type !== "modal" && 6}
          lg={type !== "modal" && 4}
          xl={type !== "modal" && 3}
        >
          <TextField
            disabled={type !== "modal"}
            fullWidth
            value={formValues?.id}
            id="outlined-basic"
            sx={{ textTransform: 'capitalize' }}
            label={t("id")}
            name="id"
            variant="outlined"
          />
        </Grid>
      )}
    </>
  );
}
